import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {CommonUtils} from '@shared/utils/utils';

@Injectable()
export class XsrfInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const csrfToken =CommonUtils.getCookieValue("CSRF-TOKEN");
      req = req.clone({
        headers: req.headers.set('CSRF-TOKEN', csrfToken),
        withCredentials: true
      });

    return next.handle(req);
  }
}
